<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qmvnFC/media/FC-9781035861255.jpg?1718046516822" alt="This image is the cover for the book The Gentlemen’s Club"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Gentlemen’s Club
      </h1>
      <p class="bookDescription body article font2">
        <p>An evil family – a husband, his three sons, and their naive wife – are involved in drugs, prostitution, and child abuse. The policeman seeking to take them down partners with a vigilante sniper who employs various ruthless tactics to eliminate the family members and their equally corrupt female cousin. Meanwhile, a well-intentioned midwife hatches a misguided scheme to swap newborns between wealthy and disadvantaged mothers in an effort to provide the babies better lives. As the plot unfolds, a romantic relationship develops between the policewoman and the sniper, complicating her response to his extra-legal actions. Central to these connected stories is the stately gentleman’s club built with council approval in the small city’s sleepy industrial quarter. With shops on the ground floor and residences above, the building’s fourth level remains strictly off limits, guarded to ensure no one discovers the dark secrets hidden within.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carole Judith Hall
      </h2>
      
      <p class="authorDescription body article">Carole and her husband spent 35 years sailing the world, visiting one hundred and thirty-five countries. She has forgotten how many ports of call they made as it must be in the hundreds. They have settled in Queensland, Australia, and are enjoying life in a beachside town on the east coast of Australia. For their retirement they have a one-acre property near their four children. Her writing every day is her greatest pleasure.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6f06407a